import { render, staticRenderFns } from "./DomainsActions.vue?vue&type=template&id=1e452aa5"
import script from "./DomainsActions.vue?vue&type=script&lang=js"
export * from "./DomainsActions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports